module.exports = __webpack_public_path__ + "img/bolonez.5737a514.png";